import { Component, Input, OnInit } from '@angular/core';

import { Subject, catchError, of, takeUntil, tap } from 'rxjs';

import { StaticApplicationId, SvcCommentCounterService } from 'projects/lib-shared-core/src/public-api';
import { AlertApplicationFeedService } from '../shared/services/alert-application-feed.service';
import { AlertErrorService } from '../shared/services/alert-error.service';
import { AlertApplicationFeed } from '../shared/interfaces/alert-application-feed.interface';
import { AlertService } from '../shared/services/alert.service';

@Component({
  selector: 'app-alert-feed-tab',
  templateUrl: './alert-feed-tab.component.html',
  styleUrls: ['./alert-feed-tab.component.scss'],
})
export class AlertFeedTabComponent implements OnInit {
  @Input() public isAddMode: boolean;
  @Input() public alertId: number;

  public alertFeedKey: string;
  public alertApplicationId: string = StaticApplicationId.alert;
  public commentsTotal: number;

  private unsubscribe$ = new Subject<void>();

  constructor(
    private _alertApplicationFeedService: AlertApplicationFeedService,
    private _alertErrorService: AlertErrorService,
    private _commentCounterService: SvcCommentCounterService,
    private _alertService: AlertService
  ) {}

  public ngOnInit(): void {
    this.getAlertFeedKey();
  }

  public ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  public getAlertFeedKey(): void {
    this._alertApplicationFeedService
      .getApplicationFeed()
      .pipe(
        tap((alertApplicationFeed: AlertApplicationFeed) => {
          this.alertFeedKey = alertApplicationFeed.feedKey;
          this.refreshCommentsTotal();
        }),
        catchError((err) => {
          this._alertErrorService.showErrorInToast(err);
          return err;
        }),
        takeUntil(this.unsubscribe$)
      )
      .subscribe();
  }

  public refreshCommentsTotal(): void {
    if (this.isAddMode || !this.alertId || !this.alertFeedKey) return;

    this._commentCounterService
      .getCountByRegistryId(this.alertId, { commentConfigTypeId: this.alertFeedKey })
      .pipe(
        catchError(() => of(0)),
        tap((total: number) => {
          this.commentsTotal = total;
        }),
        takeUntil(this.unsubscribe$)
      )
      .subscribe();
  }

  public onCommentsChanged(): void {
    this.refreshCommentsTotal();
    // AB#73047 refresh the search row totals live, like reactions and views do
    if (this.alertId) this._alertService.alertUpdated$.next(this.alertId);
  }
}
